import { render, staticRenderFns } from "./Europe40under40AwardForm.vue?vue&type=template&id=199e4a60"
import script from "./Europe40under40AwardForm.vue?vue&type=script&lang=js"
export * from "./Europe40under40AwardForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('199e4a60')) {
      api.createRecord('199e4a60', component.options)
    } else {
      api.reload('199e4a60', component.options)
    }
    module.hot.accept("./Europe40under40AwardForm.vue?vue&type=template&id=199e4a60", function () {
      api.rerender('199e4a60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/europe40under40-design-award/components/Europe40under40AwardForm.vue"
export default component.exports